import React from "react";

import Button from "../../../common/components/Button/Button";
import Context from "../../../context/Context";
import HostedMerge from "../../base/HostedMerge";
import {
  ModalController,
  WorkingController,
} from "../../../common/components/Modal";
import Topic from "../../../context/Topic";
import * as component from "../../../components/util/component";
import * as mergeUtil from "../../base/mergeUtil";

import { CalciteP } from "calcite-react/Elements";

import {
  ContentWrapper,
  HeaderContainer,
  Header,
  ContentContainer
} from "../../styles/backstageStyles";

export default class MergePlan extends React.Component {

  constructor(props){
    super(props);
    const mergePermission = Context.instance.config.spaceplanner.mergepermission;
    const groupTitle = mergePermission.groupTitle;
    this.state = component.newState({
      isWorking: true,
      noDiff: false,
      wasMerged: false,
      userAuthorized: false,
      errorAuthorizing : false,
      groupTitle: groupTitle,
      reason: null
    });
  }

  checkIfUserAuthorized(){
    const plan = Context.instance.spaceplanner.activePlan;
    var reason = "userUnAuthorized";
    this.isUserAuthorized()
    .then(resp => {
      let authorized = resp;
      if(resp === true) {
        if(plan && !plan.isVersioned){
          if(!this.isOwner()) {
            reason = "nonOwnerAdminOnline";
            authorized = false;
          }
        }
      }
      if(resp === false) {
        reason = "userUnAuthorized";
        if (plan && !plan.isVersioned) {
          if(!this.isOwner()) {
            reason = "nonMemberOwnerAdminOnline";
          }
        }
        this.getGroupTitle();
      }
      this.setState({
        userAuthorized : authorized,
        reason : reason
      })
    })
    .catch(error => {
      console.log("Error in isUserAuthorized", error);
      this.setState({
        errorAuthorizing : true
      })
      Topic.publishErrorAccessingData();
    })
  }

  componentDidMount() {
    const plan = Context.instance.spaceplanner.activePlan;
    if (plan && !plan.isVersioned) {
      if(Context.instance.user.isAdmin()) {
        this.setState({userAuthorized : true});
      }else{
        this.checkIfUserAuthorized();
      }
    }else{
      this.checkIfUserAuthorized();
    }
    if (plan.isVersioned) {
      this.checkDifferencesVersioned();
    } else {
      this.checkDifferencesHosted();
    }
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  getGroupTitle=()=>{
    const mergePermission = Context.instance.config.spaceplanner.mergepermission;
    const groupId = mergePermission.groupId;
    const portal = Context.instance.getPortal();
    var query = "id:" + groupId;
    var queryParams = {
      query: query,
      num: 100
    };
    portal.queryGroups(queryParams).then((response)=>{
      if(response && response.results && response.results.length === 1) {
        this.setState({
          groupTitle: response.results[0].title
        })
      }else{
        this.setState({
          groupTitle : mergePermission.groupTitle
        })
      }
    })
}

  isOwner =()=> {
    const plan = Context.instance.spaceplanner.activePlan;
    const item = plan.planServiceItem;
    const username = Context.instance.user.getUsername();
    const isOwner = item && (item.owner === username);
    if(isOwner) return true;
    return false;
  }

  isUserAuthorized = () => {
    const mergePermission = Context.instance.config.spaceplanner.mergepermission;
    let authorized = false;
    return new Promise((resolve, reject)=> {
      if(mergePermission.restrictUsers === true) {
        const allowMergeGroupId = mergePermission.groupId;
        const portal = Context.instance.getPortal();
          portal.user.fetchGroups()
          .then((userGroups)=> {
            userGroups.some(userGroup =>{
              const id = userGroup.id;
              if(allowMergeGroupId === id) {
                authorized = true;
                return true;
              }
            })
          })
          .then(()=> {
            resolve(authorized);
          })
          .catch(error => {
            console.log("Error in fetchGroups", error);
            reject(error);
          })
      }else{
        resolve(true);
      }
    })
  }

  checkDifferencesHosted = () => {
    this.setState({ isWorking: true });
    const hm = new HostedMerge();
    hm.hasDifferences({}).then(result => {
      let hasDiff = result && result.hasDifferences;
      this.setState({
        isWorking: false,
        noDiff: !hasDiff
      });
    }).catch(ex => {
      //this.setState({ isWorking: false });
      console.error("Error checking differences", ex);
      Topic.publishErrorAccessingData();
    });
  }

  checkDifferencesVersioned = () => {
    this.setState({ isWorking: true });
    const project = Context.instance.spaceplanner.planner.project;
    const versionManager = project.versionedInfo.versionManager;
    const options = {
      plan: Context.instance.spaceplanner.activePlan
    };
    versionManager.hasDifferences(options).then(result => {
      let hasDiff = result && result.hasDifferences;
      this.setState({
        isWorking: false,
        noDiff: !hasDiff
      });
    }).catch(ex => {
      //this.setState({ isWorking: false });
      console.error("Error checking differences", ex);
      Topic.publishErrorAccessingData();
    });
  }

  mergeClicked = () => {
    if (this.state.isWorking) return;
    const plan = Context.instance.spaceplanner.activePlan;
    plan.undoManager.clear();
    if (plan.isVersioned) {
      this.mergeVersioned();
    } else {
      this.mergeHosted();
    }
  }

  mergeHosted = () => {
    if (this.state.isWorking) return;
    this.setState({ isWorking: true });

    const i18n = Context.instance.i18n;
    const workingController = new WorkingController();
    const workingContent = i18n.spaceplanner.backstage.mergePlan.mergingPlan;
    workingController.show({}, workingContent);

    const plan = Context.instance.spaceplanner.activePlan;
    const options = {
      plan: plan
    };

    const hm = new HostedMerge();
    hm.merge(options).then(task => {
      //console.log("MergePlan mergeUtil::analyze",task)
      workingController.close();
      this.setState({
        isWorking: false,
        wasMerged: !!task.wasMerged
      });
    }).catch(ex => {
      let submessage = ex.submessage || ex.message;
      workingController.close();
      ModalController.alert({
        isError: true,
        title: i18n.spaceplanner.backstage.mergePlan.errorMergingTitle,
        message: i18n.spaceplanner.backstage.mergePlan.errorMergingMessage,
        submessage: submessage
      });
      this.setState({ isWorking: false });
      console.error("Error merging plan", ex);
    });
  }

  mergeVersioned = () => {
    if (this.state.isWorking) return;
    this.setState({ isWorking: true });

    const i18n = Context.instance.i18n;
    const workingController = new WorkingController();
    const workingContent = i18n.spaceplanner.backstage.mergePlan.mergingPlan;
    workingController.show({}, workingContent);

    const project = Context.instance.spaceplanner.planner.project;
    const versionManager = project.versionedInfo.versionManager;
    const plan = Context.instance.spaceplanner.activePlan;
    const options = {
      plan: plan,
      versionManager: versionManager,
      reconcile: true,
      applyEdits: true,
      post: true
    };
    //options.post = false;

    mergeUtil.analyze(options).then(task => {
      //console.log("MergePlan mergeUtil::analyze",task)
      workingController.close();
      this.setState({
        isWorking: false,
        wasMerged: !!task.wasMerged
      });
    }).catch(ex => {
      let submessage = ex.submessage || ex.message;
      workingController.close();
      ModalController.alert({
        isError: true,
        title: i18n.spaceplanner.backstage.mergePlan.errorMergingTitle,
        message: i18n.spaceplanner.backstage.mergePlan.errorMergingMessage,
        submessage: submessage
      });
      this.setState({ isWorking: false });
      console.error("Error merging plan", ex);
    });
  }

  render() {
    const i18n = Context.instance.i18n;
    return (
      <ContentWrapper>
        <HeaderContainer>
          <Header>{i18n.spaceplanner.backstage.mergePlan.caption}</Header>
        </HeaderContainer>
        <ContentContainer>
          {this.renderContent()}
        </ContentContainer>
      </ContentWrapper>
    )
  }

  renderContent() {
    const {isWorking, noDiff, wasMerged, userAuthorized, reason} = this.state;
    const i18n = Context.instance.i18n;
    let msg = i18n.spaceplanner.backstage.mergePlan.prompt;
    if (noDiff) {
      msg = i18n.spaceplanner.backstage.mergePlan.noDiff;
    } else if (wasMerged) {
      msg = i18n.spaceplanner.backstage.mergePlan.merged;
    } else if (!userAuthorized) {
      const plan = Context.instance.spaceplanner.activePlan;
      if (plan && !plan.isVersioned) {
        if(reason === "nonMemberOwnerAdminOnline") {
          msg = i18n.spaceplanner.backstage.mergePlan.nonMemberOwnerAdminOnline;
        }else if(reason === "nonOwnerAdminOnline") {
          msg = i18n.spaceplanner.backstage.mergePlan.nonOwnerAdminOnline;
        }else if(reason === "userUnAuthorized"){
          msg = i18n.spaceplanner.backstage.mergePlan.userUnAuthorized;
        }
      }else if(reason === "userUnAuthorized"){
        msg = i18n.spaceplanner.backstage.mergePlan.userUnAuthorized;
      }
      const groupName = this.state.groupTitle;
      if(msg.includes('{groupName}')) msg = msg.replace("{groupName}", groupName);
      if(this.state.errorAuthorizing) msg = i18n.spaceplanner.backstage.mergePlan.errorAuthorizing;
    }
    return (
      <div>
        <CalciteP>
          {msg}
        </CalciteP>
        <Button
          disabled={!userAuthorized || isWorking || noDiff || wasMerged}
          onClick={this.mergeClicked}>
          {i18n.spaceplanner.backstage.mergePlan.label}
        </Button>
      </div>
    );
  }

}
